export default "__VITE_ASSET__AQJ75_vD__"